import React, { Component } from 'react';

import { ActionCreators } from '../../actions';
import { bindActionCreators } from 'redux';
import { config } from '../../config/config';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import '../../styles/job-list';
import { newForm } from '../../config/routes';

class JobList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keyword: "",
            jobFunction: "",
            jobLocation: "",
            jobs: [],
            chosenJob: {}
        }
    }

    componentWillMount(){
        this.props.jobFunction();
        this.props.jobLocation();
        this.props.jobType();
        this.props.vacanciesPLAction().then(() => {
            this.search();
        });
    }

    search(){
        if(this.props.vacanciesPL){
            let vacancies = this.props.vacanciesPL;

            if(this.state.keyword !== ""){
                vacancies = vacancies.filter(x => x.jobTitle.toLowerCase().includes(this.state.keyword.toLowerCase()) || x.shortDesc.toLowerCase().includes(this.state.keyword.toLowerCase()) || x.requirement.toLowerCase().includes(this.state.keyword.toLowerCase()) );
            }

            if(this.state.jobFunction !== ""){
                vacancies = vacancies.filter(x => x.jobFunction.id === this.state.jobFunction);
            }

            if(this.state.jobLocation !== ""){
                vacancies = vacancies.filter(x => x.jobLocation.map( l => l.id ).indexOf(this.state.jobLocation) > -1 );
            }

            this.setState(prevState => ({
                ...prevState,
                jobs: vacancies
            }))
        }
    }

    confirmDelete(vacancy){
        this.setState(prevState => ({
            ...prevState,
            chosenJob: vacancy
        }))
    }

    cancelDelete(){
        this.setState(prevState => ({
            ...prevState,
            chosenJob: {}
        }))
    }

    delete(){
        this.props.vacancyDeleteAction(this.state.chosenJob.id).then(() => {
            if(this.props.vacancyPostState){
                let jobs = this.state.jobs.filter(x => x.id !== this.state.chosenJob.id);
                this.setState(prevState => ({
                    ...prevState,
                    jobs: jobs,
                    chosenJob: {}
                }))
            }

        })
    }
    
    viewDetail(url) {
        window.location("/job/" + url + "/detail");
    }

    _renderModal(){
        return <div className={ (this.state.chosenJob.id ? "show" : "" ) + " modal fade" } tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body text-center">
                                <h2>Please confirm!</h2>
                                <p>Are you sure to delete "{this.state.chosenJob.jobTitle}" job?</p>
                                <small className="mt-3 text-mute">
                                    <b>What will happen if you delete this job?</b>
                                    <p>This job will not be listed on open vacancies page, but don't worry all applicant datas related to this job still can be accessed by "Applicant" menu. </p>
                                </small>
                            </div>
                            <div className="modal-footer">
                                <button onClick={() => {this.delete()}} className="gs-btn gs-btn-blue">Sure!</button>
                                <button onClick={() => {this.cancelDelete()}} className="gs-btn gs-btn-grey">No. Cancel deletion!!</button>
                            </div>
                        </div>
                    </div>
                </div>
    }

    render() {
        return (
            <div className="job-list">
                { this._renderModal() }
                <div className="job-search-box">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 queryBox">
                                <input
                                    type="text"
                                    placeholder="Search job"
                                    onChange = { (event) => {
                                        this.setState({
                                            keyword: event.target.value
                                        });
                                    }}
                                    />
                            </div>
                            <div className="col-xl-3 functionBox">
                                <select
                                    value={this.state.jobFunction}
                                    onChange = { (event) => {
                                        this.setState({
                                            jobFunction: event.target.value
                                        });
                                    }}
                                    >
                                    <option value="">All functions</option>
                                    {
                                        this.props.jobFunctions &&
                                        this.props.jobFunctions.map((f, i) => {
                                            return <option key={f.id} value={f.id}>{f.function}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-xl-3 locationBox">
                                <select
                                    value={this.state.jobLocation}
                                    onChange = { (event) => {
                                        this.setState({
                                            jobLocation: event.target.value
                                        });
                                    }}
                                    >
                                    <option>All locations</option>
                                    {
                                        this.props.jobLocations &&
                                        this.props.jobLocations.map((l, i) => {
                                            return <option key={l.id} value={l.id}>{l.location}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-xl-3 searchButton">
                                {
                                    this.props.isLoggedin &&
                                    <div className="row">
                                        <div className="col-6">
                                            <button className="gs-btn gs-btn-pink" onClick={() => { this.search() }}><i className="icon-magnifier"></i></button>
                                        </div>
                                        <div className="col-6">
                                            <Link className="gs-btn gs-btn-pink" to="/aoc/job/add"><i className="icon-plus"></i></Link>
                                        </div>
                                    </div>
                                }
                                {
                                    !this.props.isLoggedin &&
                                    <button className="gs-btn gs-btn-pink" onClick={() => { this.search() }}>Search</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="careerfy-wrapper">
                    <div className="careerfy-main-content">
                        <div className="careerfy-main-section">
                            <div className="container">
                                <div className="row">
                                    <div className="careerfy-column-12 careerfy-typo-wrap">
                                        <div className="careerfy-job careerfy-job-grid">
                                            <ul className="careerfy-row">
                                            {
                                                this.state.jobs &&
                                                this.state.jobs.map((j, i) => {
                                                    if(j.jobFunctionId && this.props.jobFunctions)
                                                        j.jobFunction = this.props.jobFunctions.find(x => x.id === j.jobFunctionId);
                                                    if(j.jobTypeId && this.props.jobTypes)
                                                        j.jobType = this.props.jobTypes.find(x => x.id === j.jobTypeId);
                                                    if(j.jobLocationIds && this.props.jobLocations)
                                                        j.jobLocations = this.props.jobLocations.filter(x => this.props.jobLocations.map(l => l.id).indexOf(x.id) > -1);
                                                    return  (
                                                        <li className="careerfy-column-3" key={j.id}>
                                                            <div className="careerfy-job-grid-wrap">
                                                                <figure>
                                                                    <span className="careerfy-jobtype-label jobtype-label-blue">Full Time</span>
                                                                    <img src={ j.thumbnailFile ? config.resourcehost+"uploads/vacancies/" + j.thumbnailFile : "/images/devstack_logo.png" } alt={ j.jobTitle } />
                                                                </figure>
                                                                <div className="careerfy-jobgrid-text">
                                                                    {/* <div className="careerfy-job-tag"><a href="#">@ Massimo Artemisis</a></div> */}
                                                                    <h2>
                                                                        <Link to={{ pathname: "/job/" + j.url + "/detail", job: j }}>{ j.jobTitle }</Link>
                                                                    </h2>
                                                                    <ul className="careerfy-job-time">
                                                                        <li><a href="#">{ j.jobFunction &&  j.jobFunction.function}</a></li>
                                                                       {/* <li>{ j.publishedDay }</li> */}
                                                                    </ul>
                                                                    <span className="careerfy-job-location"><i className="careerfy-icon careerfy-maps-and-flags"></i> { j.jobLocations && j.jobLocations.map( l => l.location ).join(", ") }</span>
                                                                    {/* <a href="#" className="careerfy-job-like"><i className="fa fa-heart"></i></a> */}
                                                                    {
                                                                        this.props.isLoggedin &&
                                                                        <div>
                                                                            <div className="col">
                                                                                <Link style={{ textDecoration: "none" }} className="gs-btn-small gs-btn-blue text-center" to={{ pathname: "/aoc/job/"+j.url+"/edit", job: j }}>
                                                                                    <i className="icon-pencil"></i> Edit
                                                                                </Link>
                                                                            </div>
                                                                            <div className="col">
                                                                                <button onClick={() => { this.confirmDelete(j) }} className="gs-btn-small gs-btn-pink text-center">
                                                                                    <i className="icon-trash"></i> Delete
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {
                                                                        !this.props.isLoggedin &&
                                                                        // <Link className="gs-btn-small gs-btn-pink mt-2" to={{ pathname: "/job/"+j.url+"/apply", job: j}}>Apply Now</Link>
                                                                        <a href={newForm} target="_blank" rel="noopener noreferrer" className="gs-btn-small gs-btn-pink mt-2">Apply Now</a>
                                                                        
                                                                    }
                                                                </div>
                                                            </div>
                                                        </li>
                                                    )
                                                })
                                            }

                                            {
                                                this.state.jobs && this.state.jobs.length === 0 &&
                                                <div className="col text-center">No vacancy match the criteria.</div>
                                            }
                                            
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        jobFunctions: state.jobFunctions,
        jobLocations: state.jobLocations,
        jobTypes: state.jobTypes,
        vacanciesPL: state.vacanciesPL,
        isLoggedin: state.isLoggedin,
        vacancyPostState: state.vacancyPost
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobList));



// WEBPACK FOOTER //
// ./src/pages/unauth/jobList.js